import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import axios from '../Config/axiosConfig';
import "./Dashboard.css";

//Compartilhados
import Loading from '../Shared/Loading/Loading';
import './../Shared/sharedStyles.css';

//CHARTS
import LineChartInspecoesTodosMeses from '../Shared/Charts/LineChartInspecoesTodosMeses';
import StatisticsCards from '../Shared/Charts/StatisticsCards';
import ResultadoPieChart from '../Shared/Charts/ResultadoPieChart';
import InspetorChart from '../Shared/Charts/InspetorChart';
import DashboardExtraKpis from '../Shared/Kpis/DashboardExtraKpis';
import { buildDashboardKpis, formatKpiCutoffDate, isKpiCutoffEnabled } from '../Shared/Utils/dashboardKpis';

const formatarDataParaInput = (data) => {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
};

const criarPeriodoPadraoInspetores = () => {
  const dataFim = new Date();
  const dataInicio = new Date(dataFim);
  dataInicio.setFullYear(dataFim.getFullYear() - 1);
  if (dataInicio.getMonth() !== dataFim.getMonth()) dataInicio.setDate(0);

  return {
    dataInicio: formatarDataParaInput(dataInicio),
    dataFim: formatarDataParaInput(dataFim)
  };
};

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [inspecoesPorMesDataCurrentYear, setInspecoesPorMesDataCurrentYear] = useState([]);
  const [inspecoesPorMesDataLastYear, setInspecoesPorMesDataLastYear] = useState([]);
  const [inspecoesPorMesDataPenultimateYear, setInspecoesPorMesDataPenultimateYear] = useState([]);

  const baseApiUrl = process.env.REACT_APP_API_URL;
  const baseApi = `${baseApiUrl}/api/Dashboard`;

  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;
  const penultimateYear = currentYear - 2;

  const [dataStatisticsCards, setDataStatisticsCards] = useState({ TotalLaudos: 0, TotalOs: 0, TotalClientes: 0 });
  const [dataPieChart, setDataPieChart] = useState({ TotalGeralAprovados: 0, TotalReprovado: 0, TotalAprovadoRecomendacoes: 0, TotalOutros: 0 });
  const [dataInspecoesChartBar, setDataInspecoesChartBar] = useState([]);
  const [periodoInspetores, setPeriodoInspetores] = useState(criarPeriodoPadraoInspetores);
  const [periodoInspetoresAplicado, setPeriodoInspetoresAplicado] = useState(criarPeriodoPadraoInspetores);
  const [loadingInspetores, setLoadingInspetores] = useState(false);
  const [extraKpis, setExtraKpis] = useState(null);

  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetchInitialData();
    }
  }, []);

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const obterInspecoesTodosMesesPorAno = 'obter-inspecoes-todos-meses-por-ano';
      const responseList = await Promise.allSettled([
        axios.post(`${baseApi}/${obterInspecoesTodosMesesPorAno}`, { Ano: currentYear }),
        axios.post(`${baseApi}/${obterInspecoesTodosMesesPorAno}`, { Ano: lastYear }),
        axios.post(`${baseApi}/${obterInspecoesTodosMesesPorAno}`, { Ano: penultimateYear }),
        axios.get(`${baseApi}/obter-total-laudos-os-clientes`),
        axios.get(`${baseApi}/obter-total-conclusao-tecnica`),
        axios.get(`${baseApi}/obter-total-inspecoes-inspetor`, { params: periodoInspetores }),
        axios.get(`${baseApi}/obter-kpi-dataset`)
      ]);

      if (responseList[0].status === 'fulfilled') {
        setInspecoesPorMesDataCurrentYear(responseList[0].value.data);
      }

      if (responseList[1].status === 'fulfilled') {
        setInspecoesPorMesDataLastYear(responseList[1].value.data);
      }

      if (responseList[2].status === 'fulfilled') {
        setInspecoesPorMesDataPenultimateYear(responseList[2].value.data);
      }

      if (responseList[3].status === 'fulfilled') {
        setDataStatisticsCards(responseList[3].value.data);
      }

      if (responseList[4].status === 'fulfilled') {
        setDataPieChart(responseList[4].value.data);
      }

      if (responseList[5].status === 'fulfilled') {
        setDataInspecoesChartBar(responseList[5].value.data);
      }

      const dataset = responseList[6].status === 'fulfilled' ? responseList[6].value.data || {} : {};
      const ordensServico = dataset.ordensServico || [];
      const laudos = dataset.laudos || [];
      setExtraKpis(buildDashboardKpis({ laudos, ordensServico, includeClientRanking: true }));

    } catch (error) {
      console.log('Erro ao buscar dados:', error);
    }
    setLoading(false);
  };

  const fetchInspecoesPorInspetor = async () => {
    if (!periodoInspetores.dataInicio || !periodoInspetores.dataFim
      || periodoInspetores.dataInicio > periodoInspetores.dataFim) return;

    setLoadingInspetores(true);
    try {
      const response = await axios.get(`${baseApi}/obter-total-inspecoes-inspetor`, {
        params: periodoInspetores
      });
      setDataInspecoesChartBar(response.data);
      setPeriodoInspetoresAplicado({ ...periodoInspetores });
    } catch (error) {
      console.log('Erro ao buscar inspeções por inspetor:', error);
    } finally {
      setLoadingInspetores(false);
    }
  };

  const handlePeriodoInspetoresChange = (campo, valor) => {
    setPeriodoInspetores((periodoAtual) => ({ ...periodoAtual, [campo]: valor }));
  };

  if (loading) {
    return <Loading />;
  }

  if (inspecoesPorMesDataCurrentYear.length <= 0 && loading === false) {
    return (
        <Container>         
            <Row>
                <Col>
                    <Form>
                        <Row className='mt-3'>                          
                        </Row>                      
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

  return (
    <Container>

      <StatisticsCards data={dataStatisticsCards} />

      <LineChartInspecoesTodosMeses data={{
        currentYear: inspecoesPorMesDataCurrentYear,
        lastYear: inspecoesPorMesDataLastYear,
        penultimateYear: inspecoesPorMesDataPenultimateYear
      }}
        currentYear={currentYear}
        lastYear={lastYear}
        penultimateYear={penultimateYear}
      />

      <ResultadoPieChart dataPieChart={dataPieChart} />
      <InspetorChart
        dataInspecoes={dataInspecoesChartBar}
        dataInicio={periodoInspetores.dataInicio}
        dataFim={periodoInspetores.dataFim}
        dataInicioAplicada={periodoInspetoresAplicado.dataInicio}
        dataFimAplicada={periodoInspetoresAplicado.dataFim}
        loading={loadingInspetores}
        onDataInicioChange={(valor) => handlePeriodoInspetoresChange('dataInicio', valor)}
        onDataFimChange={(valor) => handlePeriodoInspetoresChange('dataFim', valor)}
        onFiltrar={fetchInspecoesPorInspetor}
      />
      <DashboardExtraKpis
        title="KPIs operacionais e executivos"
        subtitle="Bloco adicional sem alterar os indicadores atuais do dashboard."
        cards={extraKpis?.cards}
        validityCards={extraKpis?.validityCards}
        rankings={extraKpis?.rankings}
        cutoffDateLabel={isKpiCutoffEnabled() ? formatKpiCutoffDate() : null}
      />

    </Container>
  );

};

export default Dashboard;
